import React from 'react';
import ReactTooltip from 'react-tooltip';

function Tooltip({ id, children, delayShow, delayHide, arrowColor, className, position }) {
	return (
		<ReactTooltip
			id={id}
			className={`tooltip-hover ${className ?? 'rounded-md bg-ivory text-jetGrey px-2 py-0'}`}
			delayShow={delayShow ?? 1000}
			delayHide={delayHide ?? 500}
			effect="solid"
			place={position ?? 'bottom'}
			arrowColor={arrowColor ?? '#F6F6F6'}
		>
			{children}
		</ReactTooltip>
	);
}

export default Tooltip;
